import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFetchTable } from "@hooks/useFetchDataTable";
import BackgroundImage from "@components/BackgroundImageCst";
import Table from "@components/Table";
import HeroCst from "@components/HeroCst";
import Breadcrumb from "@components/Breadcrumb";
import { useParams } from "react-router-dom";
import { useFetchDetail } from "@hooks/useFetchDetail";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import ModalDownloadUploadCst from "@components/ModalDownloadUploadCst";
import { ActionUploadDownloadIterface } from "@components/ModalDownloadUploadCst/types";
import { GroupUser } from "src/interfaces/Group";
import ButtonBackPage from "@components/ButtonBackPage";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { useAuth } from "@context/auth";
import { useFilters } from "@context/filters";
import { useResetFilters } from "@hooks/useFiltersProvider";

const UsersGroupDynamic: React.FC = () => {
  const [openUpload, setOpenUpload] = useState<ActionUploadDownloadIterface>();
  const { id, idGroupDynamic, idGroup } = useParams();
  const { user } = useAuth();
  const { filters } = useFilters();
  const filterId = `${user?.id_user}_${PagesID["corporate.groups.user"] + "dynamic"}`;

  useResetFilters(filterId);

  const { columns, dataTable, actionsTopToolbar, actionForRow } = useFetchTable<
    GroupUser[]
  >(
    `${ServicesURL.getDynamicGroupsUsers
      .replace(":idCorporate", `${id ? id : 1}`)
      .replace(
        "::groupId",
        `${idGroupDynamic ? idGroupDynamic : idGroup || 1}`,
      )}`,
    PagesID["corporate.groups-dynamic.users"],
    filters[filterId],
  );
  const { t } = useTranslation(["user-of-groups-page"]);

  const { dataDetail: groupDetail } = useFetchDetail(
    `${ServicesURL.dynamicGroups.replace(":idCorporate", `${id ? id : 1}`)}`,
    idGroupDynamic || idGroup || "",
    PagesID["corporate.groups-dynamic.users"],
  );

  const { dataDetail } = useFetchDetail(
    ServicesURL.corporate,
    id || "",
    PagesID.corporate,
  );

  return (
    <AnimationFadeIn>
      <BackgroundImage
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-corp-groups.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={`${dataDetail?.name} - ${t(
            "hero-title",
          )} ${groupDetail?.name} `}
          description={t("hero-description")}
        />
        <ButtonBackPage />
        <Box
          sx={{
            mt: "25px",
          }}
        >
          <Table
            id={PagesID["corporate.groups.user"] + "dynamic"}
            data={dataTable?.response || []}
            columns={columns || []}
            configurationTopToolbar={actionsTopToolbar}
            configurationActionForRow={actionForRow}
            totalPages={dataTable?.metadata?.total_elements}
            modalTitle={t("hero-title")?.replace("-", "") || ""}
            enableRowActions={false}
          />
        </Box>
      </Container>
      <ModalDownloadUploadCst
        open={!!openUpload}
        setOpen={() => {
          setOpenUpload(undefined);
        }}
        title={openUpload?.labelTranslate || ""}
        data={openUpload}
      />
    </AnimationFadeIn>
  );
};

export default UsersGroupDynamic;
